export const SET_ATTACHMENT_INFO = 'SET_ATTACHMENT_INFO';
export const SET_FIELD_VALUE = 'SET_ATTACHMENT_FIELD_VALUE';
export const RESET = 'RESET_ATTACHMENT';



// WEBPACK FOOTER //
// ./src/views/Attachment/flow/actionTypes.js